import { apiClient } from '@/shared/services/apiConfig';
import { useInfiniteQuery } from '@tanstack/react-query';
import { AuditLog } from '@/shared/types/auditLogTypes';
import { PaginatedResponse } from '@/shared/types/responseTypes';

/** Infinite scroll fetch for audit logs load-more. */
export const useInfiniteAccountAuditLogs = () => {
  return useInfiniteQuery({
    queryKey: ['audit-logs-infinite'],
    queryFn: async ({ pageParam }: { pageParam: number }) => {
      const response = await apiClient.get<PaginatedResponse<AuditLog>>(
        `/api/v1/audit-logs`,
        { params: { page: pageParam } }
      );
      return response.data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _pages, lastPageParam) =>
      lastPage.isLastPage ? undefined : lastPageParam + 1,
  });
};